<div class="flex justify-start content-stretch items-stretch flex-row flex-1">
  <div class="left-banner flex flex-col justify-center items-center h-full max-xl:basis-full xl:basis-1/4 xl:grow-0 xl:shrink-0">
    <img src="/assets/unite-logo.svg" alt="Unite" class="logo">
    <button mat-raised-button="" color="primary" (click)="login()" [disabled]="isLoading" class="login-button">
      <span translate="">Login as advisor</span>
    </button>
    <div class="float-button">
      <button mat-button="" [matMenuTriggerFor]="languageMenu">
        @if (currentLanguage == 'en-US') {
          <span translate="">English</span>
        }
        @if (currentLanguage == 'nl-NL') {
          <span translate="">Dutch</span>
        }
      </button>
      <mat-menu #languageMenu="matMenu">
        <button [disabled]="currentLanguage == 'nl-NL'" mat-menu-item="" (click)="setLanguage('nl-NL')">
          <mat-icon>language</mat-icon>
          <span translate="">Set to Dutch</span>
        </button>
        <button [disabled]="currentLanguage == 'en-US'" mat-menu-item="" (click)="setLanguage('en-US')">
          <mat-icon>language</mat-icon>
          <span translate="">Set to English</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div fxHide.lt-md="" class="right-banner basis-3/4 max-xl:hidden">

  </div>
</div>